import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import history from 'app/routes/history';
import { IPagination } from 'app/types/common';
import { TeamsActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const createTeam = (data): any => action(types.CREATE_TEAM_REQUESTED, data);

export const updateTeam = (data, callbackFunction = undefined): any =>
         action(types.UPDATE_TEAM_REQUESTED, { data, callbackFunction });

export const deleteTeam = (teamId): any => action(types.DELETE_TEAM_REQUESTED, teamId);

export const getTeam = (teamId): any => action(types.GET_TEAM_REQUESTED, teamId);

export const getAllTeams = (
  pagination: IPagination = undefined,
  compile = true,
): any => action(types.GET_ALL_TEAMS_REQUESTED, { pagination, compile });

export const selectTeam = (teamId): any => action(types.SELECT_TEAM_REQUESTED, { currentTeamId: teamId });

export const selectLastTeam = (): any => action(types.SELECT_LAST_TEAM_REQUESTED, {});

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  createTeamPending: (payload): any => action(types.CREATE_TEAM_PENDING, payload),
  createTeamSuccess: (response): any => action(types.CREATE_TEAM_SUCCESS, {
    teamsById: response.entities.teams,
    currentTeamId: response.result,
  }),
  updateTeamPending: (payload): any => action(types.UPDATE_TEAM_PENDING, payload),
  updateTeamSuccess: (response): any => action(types.UPDATE_TEAM_SUCCESS, {
    teamsById: response.entities.teams,
    currentTeamId: response.result,
  }),
  updateTeamFailed: (error): any => action(types.UPDATE_TEAM_FAIL, { backendErrors: error }),
  deleteTeamFailed: (error): any => action(types.DELETE_TEAM_FAIL, { backendErrors: error }),
  deleteTeamPending: (teamId): any => action(types.DELETE_TEAM_PENDING, teamId),
  deleteTeamSuccess: (teamId): any => {
    localStorage.set(teamId, {});
    history.push('/teams');

    return action(types.DELETE_TEAM_SUCCESS, {
      currentTeamId: null,
    });
  },
  getTeamPending: (): any => action(types.GET_TEAM_PENDING, {}),
  getTeamSuccess: (response): any => action(types.GET_TEAM_SUCCESS, {
    teamsById: response.entities.teams,
    currentTeamId: response.result,
  }),
  getTeamFailed: (error): any => action(types.GET_TEAM_FAIL, { backendErrors: error }),
  getAllTeamsPending: (pagination): any => action(types.GET_ALL_TEAMS_PENDING, { pagination }),
  getAllTeamsSuccess: (response, meta): any => action(types.GET_ALL_TEAMS_SUCCESS, {
    teamsById: response.entities.teams,
    teamIds: response.result,
    meta,
  }),
  getAllTeamsFailed: (error): any => action(types.GET_ALL_TEAMS_FAIL, { backendErrors: error }),
  createTeamFailed: (error): any => action(types.CREATE_TEAM_FAIL, { backendErrors: error }),
  selectLastTeamPending: (): any => action(types.SELECT_LAST_TEAM_PENDING, {}),
  selectLastTeamFinished: (teamId): any => action(types.SELECT_LAST_TEAM_FINISHED, { currentTeamId: teamId }),
};

export default null;
